import { useWatch } from "react-hook-form";

import { FEATURE_FLAGS } from "constants/featureFlags";
import useFeatureFlag from "hooks/useFeatureFlag";
import { StopAddressType } from "types/MultiStop";

export function useIsOptionalStopAddress(stopIndex: number): boolean {
  const isOptionalPortAddressFormEnabled = useFeatureFlag(FEATURE_FLAGS.FF_WEB10382_OPTIONAL_PORT_ADDRESS_FORM);
  const stopAddressType = useWatch({ name: `schedule.stops.${stopIndex}.stop_address_type` });

  return (
    isOptionalPortAddressFormEnabled &&
    (stopAddressType === StopAddressType.AIRPORT || stopAddressType === StopAddressType.SEAPORT)
  );
}
